import { z } from 'zod';
import { MODULES, PERMISSION_LEVELS, ROLES } from '../roles';
import { FEATURE_FLAGS, LocaleSchema } from '../settings';

export const ThemePreferenceSchema = z.enum(['light', 'dark', 'system']);

export const MeSchema = z.object({
  id: z.uuid(),
  tenantId: z.uuid().nullable(),
  email: z.string().nullable(),
  matricule: z.string().nullable(),
  firstName: z.string(),
  lastName: z.string(),
  displayName: z.string(),
  title: z.string().nullable(),
  position: z.string().nullable(),
  roles: z.array(z.enum(ROLES)),
  locale: LocaleSchema,
  theme: ThemePreferenceSchema,
  permissions: z.record(z.enum(MODULES), z.enum(PERMISSION_LEVELS)),
  features: z.record(z.enum(FEATURE_FLAGS), z.boolean()),
});
export type Me = z.infer<typeof MeSchema>;

export const UpdatePreferencesSchema = z.object({
  locale: LocaleSchema.optional(),
  theme: ThemePreferenceSchema.optional(),
});
export type UpdatePreferences = z.infer<typeof UpdatePreferencesSchema>;
